import { CountryDto } from '../../../models/dtos/country.dto';
import axios from '../../axios';

export default async function getUserCountriesRequest(): Promise<CountryDto[]> {
  const response = await axios.get<CountryDto[]>(
    `${process.env.REACT_APP_BASE_URL}/users/countries`
  );
  return response.data;
}
